// SubdomainGuard.jsx
import { useEffect } from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSubdomain } from "./features/subdomainSlice";

const SubdomainGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {

    const checkSubdomain = async () => {
      if (location.pathname === "/404" || location.pathname.includes("/company") || location.pathname === "/thank-you") return;
      try {
        const hostname =   window.location.hostname; //'http://dev.register.bookinclass.co.uk';
        const parts = hostname.split('.');
        
        if (parts.length > 3) {
          let subdomain = parts[0];
          
          // Check if subdomain is "register"
          if (subdomain === "register") {
            navigate("/company");
            return;
          }
          
          const response = (await fetch(`https://api.bookinclass.co.uk/api/auth/verifysubdomain/${subdomain}`));
          const res = await response.json();
          console.log(res.code)
          if (!res.code) {
            navigate("/404");
          }else{
            localStorage.setItem("company", JSON.stringify(res.data));
            localStorage.setItem("company_logo", res.data.logo);
            localStorage.setItem("company_name", res.data.company_name);
            localStorage.setItem("banner", res.data.banner);
            dispatch(setSubdomain(subdomain));
          }
        } else {
          // No subdomain found, navigate to 404
          navigate("/404");
        }

        
      } catch (error) { console.log('error---',error);
        navigate("/404");
      }
    };

    checkSubdomain();
  }, [navigate]);

  return null; // doesn't render anything
};

export default SubdomainGuard;
